// src/api/config.js
export const API_BASE = process.env.REACT_APP_API_URL || 'https://pages.cspok.cn/api';